import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=e9023efa&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9023efa",
  null
  
)

export default component.exports